import {defineSlotRecipe} from '@chakra-ui/react3'

export const engravingStackableImageRecipe = defineSlotRecipe({
    slots: ['image'],
    variants: {
        isExpanded: {
            false: {
                image: {
                    '--engraving-text-top': '45.2%'
                }
            },
            true: {
                image: {
                    '--engraving-text-top': '46.5%'
                }
            }
        }
    }
})
